import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { LoadingBoxList } from 'components/LoadingSpinner'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'

import styles from './index.css'

@withRouter
export default class DashboardList extends React.Component {
  
  static propTypes = {
    log : PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool
  }

  static defaultProps = {
    loading: false
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Container className={styles.List}>
        <Row className={styles.Header}>
          <Col xs={4}>
            <h1>Name</h1>
          </Col>
          <Col xs={4}>
            <h1>Last Action</h1>
          </Col>
          <Col xs={4}>
            <h1>Date</h1>
          </Col>
        </Row>
        {
          this.props.loading && <LoadingBoxList />
        }
        {
          !this.props.loading &&
          Array.isArray(this.props.log) &&
          (this.props.log || []).map(({ employee_id, name, last_action, clock_on }) => {
            last_action = last_action || null
            const valid = (moment(last_action).format() !== 'Invalid date')

            return (
              <Row className={styles.Row} key={employee_id}>
                <Col xs={4}>
                  {name}
                </Col>
                <Col xs={4}>
                  <span className={
                    valid ? (
                      !clock_on ? styles.red : styles.green 
                    ) : styles.nothing
                  }>
                  {valid ? moment(last_action).format('LT').toLowerCase() : '-'}
                  {valid ? ' ('+moment(last_action).fromNow()+')' : ''}
                  </span>
                </Col>
                <Col xs={4}>
                  {valid ? moment(last_action).format('DD/MM/YYYY') : '-'}
                </Col>
              </Row>
            )
          })
        }
      </Container>
    )
  }

}



// WEBPACK FOOTER //
// ./src/lists/DashboardList/index.jsx